import { createContext, useContext } from 'react'
import { AuthStore } from './AuthStore'
import { TenantStore } from './TenantStore'
import { GuestStore } from './GuestStore'
import { UserStore } from './UserStore'
import { SettingStore } from './SettingStore'
import { ActivateStore } from './ActivateStore'
import { RoomStore } from './RoomStore'
import { WebSocketStore } from './WebSocketStore'
import { WebChatStore } from './WebChatStore'
import mitt from 'mitt'

export type TypedEvents = {
  changeTenantId: string
}

export const events = mitt<TypedEvents>()

export class RootStore {
  authStore: AuthStore
  tenantStore: TenantStore
  guestStore: GuestStore
  userStore: UserStore
  settingStore: SettingStore
  activateStore: ActivateStore
  roomStore: RoomStore
  webSocketStore: WebSocketStore
  webChatStore: WebChatStore

  constructor() {
    this.authStore = new AuthStore()
    this.tenantStore = new TenantStore(this.authStore)
    this.guestStore = new GuestStore()
    this.userStore = new UserStore()
    this.settingStore = new SettingStore()
    this.activateStore = new ActivateStore()
    this.roomStore = new RoomStore(this.authStore)
    this.webSocketStore = new WebSocketStore()
    this.webSocketStore.bind(this.roomStore)
    this.webChatStore = new WebChatStore()
  }
}

export const rootStore = new RootStore()

export const StoreContext = createContext<RootStore>(rootStore)

export const useStore = () => {
  const store = useContext(StoreContext)
  if (!store) {
    throw new Error('useStore must be used within a StoreProvider')
  }
  return store
}

export const useAuthStore = () => useStore().authStore
export const useTenantStore = () => useStore().tenantStore
export const useGuestStore = () => useStore().guestStore
export const useRoomStore = () => useStore().roomStore
export const useUserStore = () => useStore().userStore
export const useSettingStore = () => useStore().settingStore
export const useActivateStore = () => useStore().activateStore
export const useWebSocketStore = () => useStore().webSocketStore
export const useWebChatStore = () => useStore().webChatStore

export default rootStore